import { z } from 'zod';
import { tBedrockAiFormSchema } from '@modules/ai/common/forms/bedrock-ai-provider-form/bedrock-ai-form-schema';
import { getAvailableModelConfigurations, getModelDefinitions } from '@modules/ai/common/model-definitions';
import { tGoogleAiFormSchema } from '../common/forms/google-ai-provider-form/google-ai-form-schema';
import { tOpenAiFormSchema } from '../common/forms/open-ai-provider-form/open-ai-form-schema';
import { tHuggingFaceAiFormSchema } from '../common/forms/hugging-face-ai-provider-form/hugging-face-ai-form-schema';
const verifyRequiredModels = (provider, mc) => {
    var _a;
    const models = (_a = provider === null || provider === void 0 ? void 0 : provider.models) !== null && _a !== void 0 ? _a : [];
    return !(provider && !mc.filter(mc => mc.required).every(mc => models.find(m => m.id === mc.id)));
};
export const tAiSettingsFormSchema = (aiConfiguration) => {
    return z.object({
        assignedUsersLimit: z.number().min(1).nullable().optional(),
        allowDataCollection: z.boolean(),
        // Remove optional after FF allowLocalAIProvidersEnabled is removed
        allowLocalProviders: z.boolean().optional(),
        defaultProviders: z
            .array(z.string())
            .min(1, { message: 'Please select at least one AI provider as the default' }),
        provider: z
            .object({
            jetbrains: z
                .object({
                id: z.string()
            })
                .nullish(),
            openai: tOpenAiFormSchema
                .nullish()
                .refine(openai => {
                var _a;
                return verifyRequiredModels(openai, getAvailableModelConfigurations((_a = getModelDefinitions(aiConfiguration, 'openai', openai === null || openai === void 0 ? void 0 : openai.preset)) !== null && _a !== void 0 ? _a : []));
            }, {
                message: 'Required models are not configured'
            }),
            google: tGoogleAiFormSchema
                .nullish()
                .refine(google => {
                var _a;
                return verifyRequiredModels(google, getAvailableModelConfigurations((_a = getModelDefinitions(aiConfiguration, 'google')) !== null && _a !== void 0 ? _a : []));
            }, {
                message: 'Required models are not configured'
            }),
            bedrock: tBedrockAiFormSchema
                .nullable()
                .optional()
                .refine(bedrock => {
                var _a;
                return verifyRequiredModels(bedrock, getAvailableModelConfigurations((_a = getModelDefinitions(aiConfiguration, 'bedrock')) !== null && _a !== void 0 ? _a : []));
            }, {
                message: 'Required models are not configured'
            }),
            huggingFace: tHuggingFaceAiFormSchema
                .nullish()
                .refine(huggingFace => {
                var _a;
                return verifyRequiredModels(huggingFace, getAvailableModelConfigurations((_a = getModelDefinitions(aiConfiguration, 'huggingFace')) !== null && _a !== void 0 ? _a : []));
            }, {
                message: 'Required models are not configured'
            })
        })
            .refine(providerObj => Object.values(providerObj).some(Boolean), {
            message: 'At least one provider must be configured'
        })
    });
};
